
/**
 * Determines how many items to fetch per page based on initial/subsequent page settings
 */
export const getPerPage = (page: number, initialPage: number, initialPerPage: number, subsequentPerPage?: number): number => {
  if (page === initialPage) {
    return initialPerPage;
  }
  return subsequentPerPage || initialPerPage;
};
